import { forwardRef, type SelectHTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import { useFieldControl } from '@/components/portal/PortalField'

export const PortalSelect = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
  ({ className, children, id, ...props }, ref) => {
    const field = useFieldControl()
    const invalid = props['aria-invalid'] ?? (field?.invalid ? true : undefined)
    return (
      <select
        ref={ref}
        {...props}
        id={id ?? field?.id}
        aria-invalid={invalid}
        aria-describedby={props['aria-describedby'] ?? field?.describedBy}
        className={cn('prod-select', invalid && 'prod-select--invalid', className)}
      >
        {children}
      </select>
    )
  },
)
PortalSelect.displayName = 'PortalSelect'
